import type { IGptService } from '@pn/core/services/gpt/ports';
import { inferDataType } from '@pn/services/gpt/openai/inferDataType';
import { toSql } from '@pn/services/gpt/openai/toSql';

export const openaiGptService: IGptService = {
  inferDataType,
  toSql,
};
